// extracted by mini-css-extract-plugin
export default {"card":"Card_card__wwl-j","children":"Card_children__HJ01F","name":"Card_name__bPaFl","value":"Card_value__IKSvy"};